import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Td,
  Tr,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaSearch } from "react-icons/fa";
import { DataTable, EmptyState } from "../../../components/Portal/ui";
import {
  MODAL_CONTENT_SX,
  MODAL_HEADER_SX,
  MODAL_FOOTER_SX,
} from "../../../components/Portal/portalModalChrome";

/**
 * Read-only modal listing the scoring results for a consultant proposal.
 */
const ConsultantProposalMatchesModal = ({ isOpen, onClose, matches }) => {
  const { t } = useTranslation("portal");
  const items = Array.isArray(matches) ? matches : [];
  const sorted = [...items].sort((a, b) => (Number(b?.score) || 0) - (Number(a?.score) || 0));

  const columns = [
    { key: "need", label: t("partners.consultantProposals.matches.table.need", "Need"), width: "28%" },
    { key: "client", label: t("partners.consultantProposals.matches.table.client", "Client"), width: "24%" },
    { key: "score", label: t("partners.consultantProposals.matches.table.score", "Score"), width: "12%", align: "right" },
    { key: "reasoning", label: t("partners.consultantProposals.matches.table.reasoning", "Reasoning") },
  ];

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" scrollBehavior="inside">
      <ModalOverlay bg="rgba(11,31,58,.45)" />
      <ModalContent sx={MODAL_CONTENT_SX}>
        <ModalHeader sx={MODAL_HEADER_SX}>
          {t(
            "partners.consultantProposals.matches.title",
            "Matching open needs"
          )}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody p={0}>
          <DataTable
            columns={columns}
            rows={sorted}
            emptyState={
              <EmptyState
                icon={<FaSearch />}
                title={t(
                  "partners.consultantProposals.matches.empty",
                  "No matching needs above the threshold."
                )}
              />
            }
            renderRow={(m) => (
              <Tr key={m.needId}>
                <Td fontWeight="700">{m.needTitle || "-"}</Td>
                <Td>{m.clientName || "-"}</Td>
                <Td textAlign="right">{m.score != null ? m.score : "-"}</Td>
                <Td>{m.reasoning || "-"}</Td>
              </Tr>
            )}
          />
        </ModalBody>
        <ModalFooter sx={MODAL_FOOTER_SX}>
          <Button variant="secondary" size="sm" onClick={onClose}>
            {t("common.close", "Close")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConsultantProposalMatchesModal;
